module.exports = __webpack_public_path__ + "static/img/01.3761fbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/02/01.jpg
// module id = 1ohN
// module chunks = 0